module.exports = __webpack_public_path__ + "static/media/steam.67d4b7c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/socials/steam.svg
// module id = 206
// module chunks = 0